export function PronunciationGuidesTab() {
  return (
    <div className="space-y-4">
      <div className="border rounded-lg p-8">
        <p className="text-sm text-muted-foreground text-center">
          No pronunciation guides yet. Add custom pronunciations for better
          voice quality.
        </p>
      </div>
    </div>
  )
}
